import { c as _c } from "react/compiler-runtime";
import { Typography } from '@mui/material';
import { Provider, type FileSearchRecord } from '@repo/api-gw-sdk';
import { Base64 } from 'js-base64';
import { TextLink } from '@/components/shared/textLink';
import { useRoles } from '@/contexts/useRoles';
import { parseGWSAttributes } from '@/utils/gwsAttributes';
import { encodeGWSDeepLink } from '@/utils/gwsDeepLink';

// Google Workspace results deep-link into the dedicated Workspace explorer, which
// keys off the resourceId path segment; the ?file= param opens the file's parent.
export const buildFileHref = (entity: FileSearchRecord) => {
  if (entity.cloudProvider !== Provider.GoogleWorkspace) {
    return `/explorer/${entity.resourceId}?file=${Base64.encode(entity.path)}`;
  }
  // Carry the row's display attributes + snapshot in ?meta= so the explorer can
  // highlight / pin / restore this exact item without re-fetching — token paging
  // can't seek to the item's page, so it may not be on the page that opens.
  const snapshot = entity.snapshots?.[0];
  const attrs = parseGWSAttributes(snapshot?.attributes);
  // Deep-link WITHOUT a snapshot so the explorer opens in all-snapshots mode and
  // restore spans all snapshots (the user picks the point-in-time) instead of
  // pinning to the single snapshot the index happened to surface. Applies to both
  // drive files (mutable content) and emails (immutable body, but labels/metadata
  // can differ across snapshots) — one consistent search-to-explorer experience.
  const meta = encodeGWSDeepLink({
    subject: attrs.gws_email_subject,
    from: attrs.gws_email_from,
    to: attrs.gws_email_to,
    date: attrs.gws_email_date,
    size: snapshot?.size,
    mimeType: attrs.gws_mime_type
  });
  const base = `/saas-inventory/google-workspace/${encodeURIComponent(entity.resourceId)}?file=${encodeURIComponent(Base64.encode(entity.path))}`;
  return meta ? `${base}&meta=${encodeURIComponent(meta)}` : base;
};
export const PathCell = t0 => {
  const $ = _c(4);
  const {
    entity
  } = t0;
  const {
    isAuthorized
  } = useRoles();
  const displayPath = entity.displayPath || entity.path;
  let t1;
  if ($[0] !== displayPath || $[1] !== entity || $[2] !== isAuthorized) {
    t1 = entity.path && <TextLink disabled={!isAuthorized("read:files")} href={buildFileHref(entity)}><Typography sx={{
        color: "inherit"
      }}>{displayPath}</Typography></TextLink>;
    $[0] = displayPath;
    $[1] = entity;
    $[2] = isAuthorized;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};